import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Servicos from "../pages/servicos/page";
import Sobre from "../pages/sobre/page";
import Contato from "../pages/contato/page";
import Agendamento from "../pages/agendamento/page";
import GestaoContabil from "../pages/servicos/gestao-contabil/page";
import GestaoFiscal from "../pages/servicos/gestao-fiscal/page";
import RelatoriosFinanceiros from "../pages/servicos/relatorios-financeiros/page";
import GestaoPessoas from "../pages/servicos/gestao-pessoas/page";

const Noticias = lazy(() => import('../pages/noticias/page'));
const NoticiaDetalhes = lazy(() => import('../pages/noticias/[slug]/page'));
const NoticiaRSSDetalhes = lazy(() => import('../pages/noticias/rss/[id]/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminNoticias = lazy(() => import('../pages/admin/noticias/page'));
const AdminServicos = lazy(() => import('../pages/admin/servicos/page'));
const AdminConfiguracoes = lazy(() => import('../pages/admin/configuracoes/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/servicos',
    element: <Servicos />,
  },
  {
    path: '/servicos/gestao-contabil',
    element: <GestaoContabil />,
  },
  {
    path: '/servicos/gestao-fiscal',
    element: <GestaoFiscal />,
  },
  {
    path: '/servicos/relatorios-financeiros',
    element: <RelatoriosFinanceiros />,
  },
  {
    path: '/servicos/gestao-pessoas',
    element: <GestaoPessoas />,
  },
  {
    path: '/sobre',
    element: <Sobre />,
  },
  {
    path: '/contato',
    element: <Contato />,
  },
  {
    path: '/agendamento',
    element: <Agendamento />,
  },
  {
    path: '/noticias',
    element: <Noticias />,
  },
  {
    path: '/noticias/:slug',
    element: <NoticiaDetalhes />,
  },
  {
    path: '/noticias/rss/:id',
    element: <NoticiaRSSDetalhes />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/noticias',
    element: <AdminNoticias />,
  },
  {
    path: '/admin/servicos',
    element: <AdminServicos />,
  },
  {
    path: '/admin/configuracoes',
    element: <AdminConfiguracoes />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
